import axios from "axios";
import Config from "../../misc/Config";

const API_URL = Config.GFU_API_URL + "/seminar-dates";
const state = {
  seminarDate: null,
};
const getters = {
  seminarDate: (state) => state.seminarDate,
};
const actions = {
  async fetchSeminarDate({ commit }, id) {
    const response = await axios.get(API_URL + "/" + id + "/by-ref");
    console.log(response.data);
    commit("setSeminarDate", response.data);
  },
};
const mutations = {
  setSeminarDate: (state, seminarDate) => (state.seminarDate = seminarDate),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
